import toast from 'react-hot-toast';

// Label/emoji only — the point value always comes from reward.points (the
// backend-computed amount actually granted), never hardcoded here, so this
// can't silently drift out of sync with server/src/config/rewards.js the
// way a fully-hardcoded "+N points" string per type previously did.
const REWARD_LABELS = {
  DAILY_LOGIN: '🔥 Daily login reward',
  BOOK_COMPLETION: '📚 Book completed!',
  REVIEW: '⭐ Review submitted!',
  REFERRAL: '👥 Successful referral!',
  MEMBERSHIP_RENEWAL: '💎 Membership renewed!',
};

// Shows the reward toast only when a reward was actually granted — a
// duplicate/repeat trigger (refresh, re-open, retried request) resolves
// awarded: false and stays silent, per the "no toast for an already-claimed
// reward" requirement.
export function showRewardToast(reward) {
  if (!reward?.awarded) return;
  const label = REWARD_LABELS[reward.type] || '🎉 Reward earned!';
  toast.success(`${label} +${reward.points} points`);
}
